import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-forest text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img
              src="/sd-logo.png"
              alt="Sister Diamonds — Sisterhood, Power, Purpose"
              className="h-28 w-auto brightness-0 invert mb-3"
              loading="lazy"
              data-testid="footer-logo"
            />
            <p className="text-terracotta text-sm mb-4">A Volition Enterprises Company</p>
            <p className="text-white/70 mb-6 max-w-md">
              Empowering high-capacity women to walk in their power, speak their truth, 
              and build lives they don't need to escape from.
            </p>
            <div className="flex gap-4">
              <a href="https://sisterdiamonds.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                Website
              </a>
              <a href="https://www.instagram.com/crystalanddrnicole" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                Instagram
              </a>
              <a href="https://www.facebook.com/sisterdiamondsllc/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                Facebook
              </a>
              <a href="https://www.linkedin.com/company/sister-diamonds-llc/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                LinkedIn
              </a>
              <a href="https://www.tiktok.com/@crystalanddrnicole" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                TikTok
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/pathways" className="text-white/70 hover:text-white transition-colors">Pathways</Link></li>
              <li><Link to="/coaches" className="text-white/70 hover:text-white transition-colors">Our Coaches</Link></li>
              <li><Link to="/communities" className="text-white/70 hover:text-white transition-colors">Communities</Link></li>
              <li><Link to="/videos" className="text-white/70 hover:text-white transition-colors">The Vault</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li><a href="mailto:info@sisterdiamonds.com" className="text-white/70 hover:text-white transition-colors">Contact Us</a></li>
              <li><Link to="/faq" className="text-white/70 hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/privacy" className="text-white/70 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-white/70 hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        {/* Copyright & Legal Notice */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-white/50">
              <Shield className="h-4 w-4" />
              <p className="text-sm">
                &copy; {currentYear} Sister Diamonds, LLC. All rights reserved.
              </p>
            </div>
            <p className="text-xs text-white/40 text-center md:text-right max-w-md">
              Sister Diamonds&trade; is a registered trademark of Volition Enterprises, LLC. 
              This platform and all content are proprietary and protected by copyright law.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
